module.exports = __webpack_public_path__ + "static/media/kredyt_6.d218d8a8.png";